export default "__VITE_ASSET__Dj_9nOUn__"